"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigInteger = void 0;
const tslib_1 = require("tslib");
const react_native_1 = require("@aws-amplify/react-native");
const BigInteger_1 = tslib_1.__importDefault(require("./BigInteger"));
exports.BigInteger = BigInteger_1.default;
BigInteger_1.default.prototype.modPow = function modPow(e, m, callback) {
    (0, react_native_1.computeModPow)({
        base: this.toString(16),
        exponent: e.toString(16),
        divisor: m.toString(16),
    })
        .then((result) => {
        callback(null, new BigInteger_1.default(result, 16));
    })
        .catch((error) => {
        callback(new Error(error), null);
    });
};
